<template>
  <div id="facts">
    <router-link class="quit-button" to="/">
      <img src="@/assets/icons/quit.svg" />
    </router-link>
    <h1 class="title">
      European Motorways 1920–2020 <br/>Key Dates
    </h1>
    <div class="fact-single" v-for="fact in factsLO" v-bind:key="fact.year" v-bind:id="'fact-'+fact.year">
      <div>
        <div>
        <span class="year" style="flex-grow: 1;">{{fact.year}}</span>
          <div class="measure" style="">
            <!--<div class='fact-compass' ></div>-->
            <!--
            <div class="fact-scale" >
              <span class="small-text">20km / 13.7 mi</span>
              <div class="scale-line"><div></div></div>
            </div>
            -->
          </div>
        </div>
        <div>
          <img :src="require('@/assets/imgs/facts/facts-all_'+fact.year+'.png')"/>
        </div>
      </div>
      <div>
        <span class="mobile-year mobile">{{fact.year}}</span>
        <span class="title">{{fact.title}}</span>
        <div class="text">{{fact.text}}</div>
        <div class="fact-single-footer">
          <img v-if="fact.year==1958" :src="require('@/assets/badges/'+fact.year+'_horizontal.svg')" onerror="this.style.display='none'"/>
          <img v-else-if="fact.hasBadge" :src="require('@/assets/badges/'+fact.year+'.svg')" onerror="this.style.display='none'"/>
          <!--<div class="highway-name">Frankfurt-Darmstadt</div>-->
            <div class="highway-length small-text"><span v-if="fact.distance">{{(fact.distance).toLocaleString('en-US')}} km / {{Number.parseFloat((fact.distance*0.6213).toFixed(1)).toLocaleString('en-US')}} mi</span></div>
            <router-link class="map-link" v-bind:to="'/'+fact.year">
              View on Map
            </router-link>
            <social-sharing v-bind:url="baseURL+'/commissions/european-motorways-1920-2020/'+fact.year+'/'"
            v-bind:title="fact.title"
            v-bind:description="fact.year+'–'+fact.text"
            inline-template>
              <div class="fact-share">
                <a><network network="facebook"><img src="@/assets/icons/share-fb.svg"/></network></a>
                <a><network network="twitter"><img src="@/assets/icons/share-tw.svg"/></network></a>
              </div>
            </social-sharing>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters} from 'vuex'

export default {
  name: 'facts',
  components: {

  },
  computed: {
    ...mapGetters(['facts','baseURL']),
    factsLO: function(){
      return this.facts.slice(1);
    },
    visibleFactYear: {
      get() { return this.$store.state.visibleFactYear; },
      set(d) { this.$store.commit('setVisibleFactYear', d); },
    },
    resetScroll: {
      get() { return this.$store.state.resetScroll; },
      set(d) { this.$store.commit('setResetScroll', d); },
    },
  },
  mounted: function() {
    this.resetScroll = true;
    if(this.visibleFactYear>0){
      document.getElementById('fact-'+this.visibleFactYear).scrollIntoView();
      this.visibleFactYear = 0;
    } else{
      window.scrollTo(0,1);
    }
  }
}
</script>
<style lang="scss">
  h1.title{
      font-size:2.86em;
      color:#FF6063;
      font-weight: lighter;
      margin-bottom:4.05em;
  }

  #facts{
    padding-top:3em;
    background:rgba(0,0,0,0.9);
    width:100vw;
    box-sizing: border-box;
    padding-left:1.63em;
    padding-right:1.63em;
    position:relative;
    z-index:1;
  }
  #facts *{
  }
  #facts >*{

    max-width: 1542px;
    margin-left:auto;
    margin-right:auto;
  }
  .fact-single .title{
    font-size:1.63em;
    margin-bottom:1.63em;
    display:block;
    max-width: 18em;

  }
  #facts .text{
    font-size:1.00em;
    font-weight: lighter;
    line-height: 1.35;
    max-width: 30em;
    flex-grow:1;
  }
  #facts .year{
    font-size:2.86em;
    color:#FF6063;
  }


  .fact-single-footer .map-link{
    font-size: 1em;
    color:#707070;
    align-self: flex-end;
  }

  .fact-single-footer .map-link:hover{
    color:white;
  }

  .fact-single-footer .highway-length{
    line-height:1.5em;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 1;
  }

  .fact-single-footer{
    display:flex;
  }
  .fact-single-footer >*:not(:last-child) {
    margin-right:1rem;
  }

  .fact-single-footer img{
    height:1.5em;
    min-height: 25px;
    min-width: 25px;

  }
  .measure{
    display:flex;
    flex-direction:row;
  }

  .measure >*{
    float:left;
    margin:0px;
  }

  .measure .fact-compass{
    margin-right:0.5em;
    margin-left:0em;
  }

  .fact-single{
    border-top:1px solid white;
    padding-top:4.05em;
    padding-bottom:4.05em;
    box-sizing: border-box;
    height:25.9em;
    display:flex;

  }

  .fact-single >div:nth-child(1) {
    height:100%;
    display:flex;
    flex-grow:1;
    >div:nth-child(1) {
      display:flex;
      flex-direction:column;
      flex-grow:1;
    }
    >div:nth-child(2) {
      flex-grow:1;
      min-width: 100px;
      padding-left: 0.76em;
      padding-right: 0.76em;
      display:flex;
      align-items: baseline;
      justify-content: center;
      box-sizing: border-box;
      height:100%;
    }
    img{
        max-height:100%;
        max-width:100%;
        width:auto;
    }
  }
  .fact-single >div:nth-child(2) {
    display: flex;
    flex-direction: column;
    flex-grow:3;
  }

  .fact-single >div:nth-child(1)

  .fact-single >*{
    height:100%;
  }
  .mobile{
    display:none;
  }
  .mobile-year{
    font-size:1.35em;
    color:#FF6063;
    margin-bottom:1.6em;
  }

  #facts{
    h1{
      margin-bottom: 2.6rem;
    }
    #fact-1924{
      border-top:none !important;
    }
  }
</style>
